import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
var FileUploader = function (_a) {
    var disabled = _a.disabled, disabledText = _a.disabledText, maxFiles = _a.maxFiles, uploadFiles = _a.uploadFiles;
    var _b = useState(false), uploading = _b[0], setUploading = _b[1];
    var theme = useTheme();
    var _c = useDrop(function () { return ({
        accept: [NativeTypes.FILE],
        canDrop: function (item) {
            if (disabled) {
                return false;
            }
            else if (!maxFiles) {
                return true;
            }
            var filesItem = item;
            return Boolean(filesItem && filesItem.files.length <= maxFiles);
        },
        collect: function (monitor) {
            var item = monitor.getItem();
            if (item && item.files.length > 0) {
                setUploading(true);
                uploadFiles.apply(void 0, item.files).catch(function (err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                })
                    .finally(function () { return setUploading(false); });
            }
            return {
                canDrop: monitor.canDrop(),
                isOver: monitor.isOver()
            };
        }
    }); }, [disabled]), _d = _c[0], canDrop = _d.canDrop, isOver = _d.isOver, drop = _c[1];
    var isActive = canDrop && isOver && !disabled;
    return (_jsxs(_Fragment, { children: [uploading && (_jsx(Backdrop, { open: true, children: _jsx(CircularProgress, {}) })), _jsx(Paper, { sx: {
                    alignItems: 'center',
                    backgroundColor: theme.palette.action.disabledBackground,
                    display: 'flex',
                    height: 100,
                    justifyContent: 'center'
                }, ref: drop, variant: "outlined", children: _jsx(Typography, { sx: { m: '13px 13px' }, color: disabled ? theme.palette.text.disabled : theme.palette.text.primary, children: isActive
                        ? 'Release to drop'
                        : disabled
                            ? disabledText || ''
                            : "Drag ".concat(maxFiles ? "up to ".concat(maxFiles, " ") : '', "files here") }) })] }));
};
export default FileUploader;
